import { useDispatch } from 'react-redux';
import { checkAgreements, retrieveAgreements } from '../agreements';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';

export function useAgreements() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // Return a handler to do the agreements check
  const handleAgreements = async (user) => {
    const agreementsData = await retrieveAgreements(dispatch, user);
    const needToAgree = checkAgreements(agreementsData, user);
    const match = (path) => matchPath({ path, end: false }, location.pathname);
    // const match = (path) => window.location.pathname.startsWith(path);
    const agreementsMatch = match('/agreements');

    if (agreementsMatch && !needToAgree) {
      // window.location.href = '/dashboard';
      navigate('/dashboard', { replace: true });
    }

    if (!agreementsMatch && needToAgree) {
      // window.location.href = '/agreements';
      navigate('/agreements', { replace: true });
    }

    return null;
  };

  return handleAgreements;
}
